import { RootState } from "@/store";
import { HyperlinkItem } from "@/types/HyperlinkItem";
import { ApiProxy, ApiCallResult } from "@infoland/api-proxy";
import { ActionTree, GetterTree, Module, MutationTree } from "vuex";
import snackBarService from "../../../services/snackBarService";
export interface HyperlinksState {}
export function initialize(): HyperlinksState {
    return {};
}
// initial state
const state: HyperlinksState = initialize();
// getters for this store
const getters: GetterTree<HyperlinksState, RootState> = {};
// mutations for this store
const mutations: MutationTree<HyperlinksState> = {};
// actions for this store
const actions: ActionTree<HyperlinksState, RootState> = {
    async createHyperlink({ commit }, hyperlink: HyperlinkItem): Promise<string> {
        const path = `/hyperlinks`;
        const response: ApiCallResult<string> = await ApiProxy.postRequest(snackBarService.setMessage, path, hyperlink);
        if (response.statusCode == 201) {
            return response.result?.created_identifier;
        } else return null;
    }
};
// export the namespace
export const namespace = "hyperlinks";
// export the store 'module'
export default <Module<HyperlinksState, RootState>>{
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};
